import { Value } from '.';

export class Verb extends Value {}
